import React from 'react';
import MortgageForm from "../../../../../components/data-capture/MortgageForm";

function ApplicationForm({section, inExtWindow = true}) {

    const target = section.data?.debtType === 'LOAN' ? `applicant${section.applicant}.debts[${section.index}]` : null
    if (!target) {
        return null
    }

    const questions = [
        {
            label: "Account No.",
            name: "accountNumber",
            answer: {
                type: "text",
            },
            target: `${target}.accountNumber`,
        }
    ]
    if (section.data?.debtType === 'LOAN') {
        questions.push({
            label: "Is Closed",
            name: "isClosed",
            answer: {
                type: "choice",
                choices: [
                    {text: "Yes", value: true},
                    {text: "No", value: false},
                ],
            },
            target: `${target}.isClosed`,
        })
        questions.push({
            label: "Is Newly Opened",
            name: "isNewAccount",
            answer: {
                type: "choice",
                choices: [
                    {text: "Yes", value: true},
                    {text: "No", value: false},
                ],
            },
            target: `${target}.isNewAccount`,
        })
        questions.push({
            label: "Cleared Before Mortgage",
            name: "clearedBeforeMortgage",
            answer: {
                type: "choice",
                choices: [
                    {text: "Yes", value: true},
                    {text: "No", value: false},
                ],
            },
            target: `${target}.clearedBeforeMortgage`,
        })
    }
    return (
        <MortgageForm inExtWindow={inExtWindow} questions={questions}/>
    );
}

export default ApplicationForm;